import axios from 'axios';
import { appConfig } from '../../Config/app';

const authAPI = axios.create({
  baseURL: appConfig.API_BASE_URL,
  headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
});

const dataToFormData = data => {
  const formData = new FormData();
  for (const key in data) {
    if (Object.hasOwnProperty.call(data, key)) {
      const element = data[key];
      formData.append(key, element);
    }
  }

  return formData;
};

function apiGetShoot(action) {
  const headers = {
    Accept: 'application/json',
    Authorization: `Token ${action.token}`,
  };

  return authAPI.get(`/api/v1/shoot/${action.project_id}/project/`, {
    headers,
  });
}

function apiUpdatePermission(action) {
  const headers = {
    Accept: 'application/json',
    Authorization: `Token ${action.token}`,
  };
  const data = {
    role_name: action.role_name,
  };
  return authAPI.post(
    `/api/v1/project/${action.project_id}/${action.user_id}/change_role`,
    data,
    {
      headers,
    },
  );
}
function apiRemovePermission(action) {
  const headers = {
    Accept: 'application/json',
    Authorization: `Token ${action.token}`,
  };
  const data = {
    role_name: action.role_name,
  };
  return authAPI.post(
    `/api/v1/project/${action.project_id}/${action.user_id}/remove_role/`,
    data,
    {
      headers,
    },
  );
}

// JSON patch of ShootSetup fields (scale, status, selected image).
function apiPatchShoot(action) {
  const headers = {
    Accept: 'application/json',
    Authorization: `Token ${action.token}`,
  };
  return authAPI.patch(`/api/v1/shoot/${action.shoot_id}/`, action.data, {
    headers,
  });
}

// --- Shoot background images (ShootImage sub-resource) ---
// Uploads are multipart, like other image fields (axios strips the JSON
// Content-Type for FormData and sets the boundary).

// POST -> add a new background to the shoot.
function apiAddShootBackground(action) {
  const headers = {
    Accept: 'application/json',
    Authorization: `Token ${action.token}`,
  };
  const formData = dataToFormData(action.data);
  return authAPI.post(
    `/api/v1/shoot/${action.shoot_id}/backgrounds/`,
    formData,
    { headers },
  );
}

// PUT -> replace an existing background's file.
function apiReplaceShootBackground(action) {
  const headers = {
    Accept: 'application/json',
    Authorization: `Token ${action.token}`,
  };
  const formData = dataToFormData(action.data);
  return authAPI.put(
    `/api/v1/shoot/${action.shoot_id}/backgrounds/${action.image_id}/`,
    formData,
    { headers },
  );
}

// DELETE -> remove a background.
function apiDeleteShootBackground(action) {
  const headers = {
    Accept: 'application/json',
    Authorization: `Token ${action.token}`,
  };
  return authAPI.delete(
    `/api/v1/shoot/${action.shoot_id}/backgrounds/${action.image_id}/`,
    { headers },
  );
}

function apiRelatedProject(action) {
  console.log('action in service', action);
  const headers = {
    Accept: 'application/json',
    Authorization: `Token ${action.token}`,
  };
  return authAPI.get(`/api/v1/project/related-project/${action.air_id}/`, {
    headers,
  });
}

export const shootServices = {
  apiGetShoot,
  apiPatchShoot,
  apiAddShootBackground,
  apiReplaceShootBackground,
  apiDeleteShootBackground,
  apiUpdatePermission,
  apiRelatedProject,
  apiRemovePermission,
};
